var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesumidificadoricon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 37,
    viewBox: "0 0 27 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desumidificador_icon",
    "data-name": "desumidificador icon",
    transform: "translate(-36 -519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_22995",
    "data-name": "Ret\\xE2ngulo 22995",
    transform: "translate(36 519)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 33,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 32,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_22996",
    "data-name": "Ret\\xE2ngulo 22996",
    transform: "translate(39 551)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H6A0,0,0,0,1,6,0V3A2,2,0,0,1,4,5H2A2,2,0,0,1,0,3V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,.5H5a.5.5,0,0,1,.5.5V3A1.5,1.5,0,0,1,4,4.5H2A1.5,1.5,0,0,1,.5,3V1A.5.5,0,0,1,1,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_22997",
    "data-name": "Ret\\xE2ngulo 22997",
    transform: "translate(54 551)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H6A0,0,0,0,1,6,0V3A2,2,0,0,1,4,5H2A2,2,0,0,1,0,3V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,.5H5a.5.5,0,0,1,.5.5V3A1.5,1.5,0,0,1,4,4.5H2A1.5,1.5,0,0,1,.5,3V1A.5.5,0,0,1,1,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_37916",
    "data-name": "Caminho 37916",
    d: "M-22904.832,6006.417h16.844",
    transform: "translate(22946.045 -5482.566)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_37917",
    "data-name": "Caminho 37917",
    d: "M-22904.832,6006.417h16.844",
    transform: "translate(22946.045 -5479.654)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_37918",
    "data-name": "Caminho 37918",
    d: "M-22904.832,6006.417h16.844",
    transform: "translate(22946.045 -5476.742)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_37919",
    "data-name": "Caminho 37919",
    d: "M-22904.832,6006.417h16.844",
    transform: "translate(22946.045 -5473.829)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_37920",
    "data-name": "Caminho 37920",
    d: "M-22904.832,6006.417h16.844",
    transform: "translate(22946.045 -5470.917)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_503",
    "data-name": "Elipse 503",
    transform: "translate(41 539)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_504",
    "data-name": "Elipse 504",
    transform: "translate(50 541)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_505",
    "data-name": "Elipse 505",
    transform: "translate(55 541)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.75,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesumidificadoricon);
export default __webpack_public_path__ + "static/media/desumidificador icon.4a455293f9d32f479a68434d0f27b45a.svg";
export { ForwardRef as ReactComponent };